import Header from '../../components/common/header/index.vue'
import Bottom from '@/components/common/bottom/index.vue'
import axios from 'axios'
export default {
  name: 'yjztDetail',
  components: { Header, Bottom },
  data () {
    return {
      detailName: '',
      detailFrom: '',
      detailInfo: null,
      literature: []
    }
  },
  watch: {
    $route() {
      this.init()
    }
  },
  // 创建元素
  mounted () {
    this.init()
  },
  // 方法定义
  methods: {
    // 初始化
    init () {
      this.detailName = this.$route.query.name
      this.detailFrom = this.$route.query.from
      this.getYjztDetail()
      this.getliterature()
    },

    getYjztDetail () {
      const self = this
      axios.get('/yuhuamenhu/special/getOneByName', {
        params: {
          name: this.detailName,
          from: this.detailFrom
        }
      }).then(json => {
        if (json.data.code === 200) {
          self.detailInfo = json.data.data
        } else {
          self.$message.warning(json.data.message)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 在线阅读
    readFn () {
      const self = this
      const formData = new FormData()
      formData.append('dbCode', self.detailInfo.dbCode)
      formData.append('sysId', self.detailInfo.sysId)
      axios.post('/juanzong/file/sso/viewList', formData).then(json => {
        if (json.data.status === '1') {
          const url = `http://files.travel-yuhuatai.com:84/file-view?dbCode=${self.detailInfo.dbCode}&sysId=${self.detailInfo.sysId}&fileId=${json.data.result.fileList[0].fileId}`
          window.open(url, '_blank')
        } else {
          self.$message.warning(json.data.message)
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // PDF下载
    downloadFn () {
      const self = this
      const formData = new FormData()
      formData.append('dbCode', self.detailInfo.dbCode)
      formData.append('sysId', self.detailInfo.sysId)
      axios.post('/juanzong/file/sso/downloadList', formData).then(json => {
        if (json.data.status === '1') {
          const url = `http://files.travel-yuhuatai.com:84/file/sso/fileDownload?dbCode=${self.detailInfo.dbCode}&sysId=${self.detailInfo.sysId}&fileId=${json.data.result.fileList[0].fileId}`
          window.open(url, '_blank')
        } else {
          self.$message.warning(json.data.message)
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 获取相关文献
    getliterature () {
      axios.get('/yuhuamenhu/special/getSortAbout', {
        params: {
          name: this.detailName
        }
      }).then(json => {
        if (json.data.code === 200) {
          this.literature = json.data.data
        } else {
          this.$message.warning(json.data.message)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取相关文献详情
    getItemFn (val) {
      console.log(val);
      this.$router.push({
          path: "/yjztDetail",
          query: {
            name: val.name,
            from: val.from
          }
      })
    }

  }
}
